const PREFIF = "address_nudge_tooltip";

export const ADDRESS_NUDGE_TOOLTIP_TEST_IDS = {
    CONTAINER: `${PREFIF}_container`,
    TEXT: `${PREFIF}_text`,
    ICON: `${PREFIF}_icon`,
    CLOSE_BUTTON: `${PREFIF}_close_button`,
};
